"use strict";

module.exports = {
  CLASSIC_WEDDING_INVITATIONS: 'Classic Wedding Invitations',
  CLASSIC_WEDDING_INVITATION_REPRINTS: 'Classic Wedding Invitation Reprints',
  FLORAL_WEDDING_INVITATIONS: 'Floral Wedding Invitations',
  FLORAL_WEDDING_INVITATION_REPRINTS: 'Floral Wedding Invitation Reprints',
  LETTERPRESS_WEDDING_INVITATIONS: 'Letterpress Wedding Invitations',
  LETTERPRESS_WEDDING_INVITATION_REPRINTS: 'Letterpress Wedding Invitation Reprints',
  LETTERPRESS_WEDDING_INVITATION_REPRINTS_COVID: 'Letterpress Wedding Invitation Reprints Covid',
  RIBBON_WEDDING_INVITATIONS: 'Ribbon Wedding Invitations',
  RIBBON_WEDDING_INVITATION_REPRINTS: 'Ribbon Wedding Invitation Reprints',
  VELLUM_WEDDING_INVITATIONS: 'Vellum Wedding Invitations',
  VELLUM_WEDDING_INVITATION_REPRINTS: 'Vellum Wedding Invitation Reprints',
  FLAT_WEDDING_INVITATION_REPRINTS_COVID: 'Flat Wedding Invitation Reprints Covid'
};